import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";

const styles = () => ({
  group: {
    flexDirection: "row",
  },

  formControlLabel: {
    fontSize: "12px",
    color: "rgb(113, 115, 123)",
  },
});

class IsIncludeConsolidatedControl extends React.Component {
  // 複数のキーワード検索の種類があるので、それぞれに対応できるように抽象度を高めに記載しています。
  render() {
    const { classes, typeKey, disabled } = this.props;

    const type = "is_include_consolidated_search_" + typeKey;

    return (
      <div style={this.props.style}>
        <RadioGroup
          className={classes.group}
          value={this.props.isIncludeConsolidatedSearch ? "true" : "false"}
          onChange={(e) => this.props.handleChange(e, type)}
        >
          <FormControlLabel
            value="true"
            control={<Radio color="primary" />}
            label="連結"
            classes={{ label: classes.formControlLabel }}
            disabled={disabled}
          />
          <FormControlLabel
            value="false"
            control={<Radio color="primary" />}
            label="単体"
            classes={{ label: classes.formControlLabel }}
            disabled={disabled}
          />
        </RadioGroup>
      </div>
    )
  }
}

IsIncludeConsolidatedControl.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  isExclude: PropTypes.bool,
  disabled: PropTypes.bool,
  typeKey: PropTypes.string.isRequired,
  isIncludeConsolidatedSearch: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

IsIncludeConsolidatedControl.defaultProps = {
  isExclude: false,
}

export default withStyles(styles)(IsIncludeConsolidatedControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/IsIncludeConsolidatedControl.jsx